import React from 'react';
import PropTypes from 'prop-types';

export default class AbstractInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      initialized: props.initialized,
      value: this.props.value,
      suspended: this.supendedLabel(props),
      valid: props.valid,
      error: null
    };
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.update = this.update.bind(this);
    this.keepOnlyRegex = this.keepOnlyRegex.bind(this);
  }

  componentDidMount() {
    this.update(this.state.value);
  }

  static getDerivedStateFromProps(props, state) {
    // New state.
    const newState = {};
    // If the initialized has changed.
    if (props.initialized != state.initialized) {
      // Updates the value.
      newState.initialized = props.initialized;
    }
    // If the value has changed.
    if (props.value != state.value) {
      // Updates the value.
      newState.value = props.value;
    }
    // If the validity has changed.
    if (props.valid != state.valid) {
      // Updates the value.
      newState.valid = props.valid;
    }
    // Returns the new state.
    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    // If the component is just now initialized.
    if ((!prevState.initialized && this.state.initialized) || (!this.isEmpty(this.state.value) && prevState.value !== this.state.value)) {
      // Updates the value once again.
      this.update(this.state.value);
    }
  }

  focus() {
    this.setState({ suspended: true, focus: true });
  }

  blur() {
    if (this.isEmpty(this.state.value)) {
      this.setState({ suspended: false, focus: false });
    }
  }

  keepOnlyRegex(value, regex, currentChar = 0) {
    // If current char is the last char.
    if (value == null || value === 'undefined' || value.toString().length == currentChar) {
      // Returns the given value.
      return value;
    }
    // If current char is not the last char.
    
      // Gets the value to test for validity.
      const testValue = value.toString().substring(0, currentChar) + value.toString().substring(currentChar, currentChar + 1);
      // If the value is valid.
      if (regex.test(testValue)) {
        // Moves to the next char validation.
        return this.keepOnlyRegex(value, regex, currentChar + 1)
      }
      // If the value is not valid.
      
        // Removes the current char.
        const newValue = value.toString().substring(0, currentChar) + value.toString().substring(currentChar + 1);
        // Checks for validity without the invalid value.
        return this.keepOnlyRegex(newValue, regex, currentChar)
      
    
  }

  isEmpty(value) {
    return (value === null || value === undefined || value === "");
  }

  supendedLabel(state) {
    return !this.isEmpty(state.value);
  }


  update(value) {
    // Gets the value from the input.
    let newValue = ((!value || (typeof value.target === 'undefined')) ?
      value : this.props.valueAttribute(value.target));
    // Applies the mask pattern.
    newValue = this.keepOnlyRegex(newValue, new RegExp("^" + this.props.maskPattern + "$"));
    // Apply format
    if (this.props.formatMask && newValue !== null) {
      newValue = this.format(this.props.formatMask, newValue)
    }

    if (this.props.formatFunction && newValue !== null) {
      newValue = this.props.formatFunction(newValue)
    }

    // Applies the content pattern.
    const contentValue = this.keepOnlyRegex(newValue, new RegExp("^" + this.props.contentPattern + "$"));
    // Checks if value is valid.
    const valid = (!this.props.mandatory && this.isEmpty(contentValue)) ||
      (new RegExp("^" + this.props.validationPattern + "$").test(contentValue) &&
        this.props.validationFunction(contentValue));
    // Calls the on change passing only the content.
    this.props.onChange(contentValue, valid);
    // If the input has been initialized or if the input is not empty anymore.
    const initialized = this.state.initialized || !this.isEmpty(contentValue);
    // If the value is not valid and the input has been initialized.
    const error = !initialized || valid ? null : this.props.validationMessage;

    // New state
    const newState = { value: newValue, valid, initialized, error };
    // If the label should be suspended.
    newState.suspended = this.supendedLabel(newState);
    // Updates the state of the component.
    this.setState(newState);
    // Returns the value.
    return newValue;
  }

  format(mask, value) {
    const stringValue = value.toString()
    let formatedString = ''
    for (let im = 0, is = 0; im < mask.length && is < stringValue.length; im++) {
      if (mask.charAt(im) === 'X') {
        formatedString = formatedString.concat(stringValue.charAt(is))
        is++
      } else if (stringValue.charAt(is) !== mask.charAt(im)) {
          formatedString = formatedString.concat(mask.charAt(im))
        } else {
          formatedString = formatedString.concat(mask.charAt(im))
          is++
        }
    }
    return formatedString;
  }
}

AbstractInput.propTypes = {
  divClassName: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  initialized: PropTypes.bool,
  valueAttribute: PropTypes.func,
  value: PropTypes.string,
  valid: PropTypes.bool,
  onChange: PropTypes.func,
  maskPattern: PropTypes.string,
  contentPattern: PropTypes.string,
  validationPattern: PropTypes.string,
  validationFunction: PropTypes.func,
  validationMessage: PropTypes.string,
  mandatory: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  errorClassName: PropTypes.string
};

AbstractInput.defaultProps = {
  divClassName: "",
  type: "text",
  id: "",
  initialized: false,
  valueAttribute: target => target.value,
  value: "",
  valid: true,
  onChange: (value) => value,
  maskPattern: ".*",
  contentPattern: ".*",
  validationPattern: ".*",
  validationFunction: (value) => true,
  validationMessage: "Invalid value",
  mandatory: false,
  className: "",
  label: "",
  labelClassName: "",
  errorClassName: "negative"
};
